import { Card, CardContent, CardMedia, Typography, styled } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import { Fragment } from 'react';

const CardFrame = styled(Card)(({ theme }) => ({
	width: '30%',
	boxShadow: 'none',
	backgroundColor: '#FBFBFC',
	[theme.breakpoints.down('sm')]: {
		width: '100%',
	},
	'&:hover': {
		cursor: 'pointer',
		'& #blog-card-media': {
			transform: 'scale(1.05)',
			transition: 'transform 0.2s',
		},
	},
	alignSelf: 'start',
}));

const CardContentCategory = styled(Typography)({
	fontSize: 'var(--font-size-default)',
	color: '#012966',
});

const CardContentTitle = styled(Typography)({
	fontSize: 'var(--font-size-sm)',
	color: '#2A2A2A',
	fontWeight: 600,
	margin: '0.4rem 0',
});

const CardContentDescription = styled(Typography)({
	fontSize: 'var(--font-size-default)',
	color: '#2A2A2A',
});

const CardImage = styled(CardMedia)({
	height: 245,
	backgroundSize: 'cover',
	backgroundPosition: 'center',
});

export const DpBlogCard = ({
	category,
	title,
	description,
	image,
	href,
}: {
	category: string;
	title: string;
	description: string;
	image: string;
	href: string;
}) => (
	<CardFrame>
		<Linkable href={href}>
			<Fragment>
				<CardImage id="blog-card-media" image={image} title="green iguana" />
				<CardContent sx={{ paddingX: 0 }}>
					<CardContentCategory>{category}</CardContentCategory>
					<CardContentTitle>{title}</CardContentTitle>
					<CardContentDescription>{description}</CardContentDescription>
				</CardContent>
			</Fragment>
		</Linkable>
	</CardFrame>
);
